import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1091.78"
      height="328.58"
      data-name="Layer 1"
      viewBox="0 0 1091.78 828.58"
      style={{maxWidth: '100%'}}
    >
      <defs>
        <linearGradient
          id="c6e87aad-8151-4bb2-867f-5915ddeef7a8"
          x1="581.24"
          x2="581.24"
          y1="811.56"
          y2="226.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="gray" stopOpacity="0.25"></stop>
          <stop offset="0.54" stopColor="gray" stopOpacity="0.12"></stop>
          <stop offset="1" stopColor="gray" stopOpacity="0.1"></stop>
        </linearGradient>
      </defs>
      <path
        fill="#536dfe"
        d="M1132 274.72c-.19.89-.37 1.78-.58 2.66-6.56 30.25-17.28 59.4-33.22 86.17-.53.89-1.06 1.78-1.6 2.67a247.62 247.62 0 01-37.45 47.27c-7.94 7.84-16.6 15.29-26.9 20.66-14.43 7.54-31.3 10.6-47.88 13.1-17.22 2.61-34.68 4.79-52.09 7.14q-9.28 1.23-18.45 2.61c-16.82 2.49-33.52 5.37-49.82 9.19-20.15 4.71-39.68 10.88-58.13 19.56q-2.21 1-4.37 2.12c-1.44.72-2.89 1.45-4.31 2.19s-2.82 1.48-4.21 2.24c-.72.39-1.44.78-2.15 1.19s-1.41.77-2.1 1.17a308.44 308.44 0 00-6.16 3.55l-.08.05c-1.35.79-2.68 1.6-4 2.41-7.54 4.58-14.92 9.36-22.3 14.17l-4.64 3-7.19 4.65c-1.4.91-2.83 1.82-4.24 2.72-1 .66-2 1.32-3.09 2-5.24 3.3-10.55 6.54-16 9.63a245.3 245.3 0 01-3.9 2.2 221.65 221.65 0 01-34.42 15.52l-.16.06a157 157 0 01-18.28 5.16c-3.57.78-7.15 1.42-10.77 1.91a115.46 115.46 0 01-29.2.41c-19.07-2.21-36.94-9.53-56-12-39.24-5-77.35 11.11-114.25 23.73q-13.61 4.65-27.42 8.71c-6.12 1.81-12.26 3.52-18.45 5.17A694.23 694.23 0 01292.49 608a325.86 325.86 0 01-49.15 1.09c-6.23-.38-12.39-1-18.44-2-20.7-3.2-40-9.91-55.58-22.2-12.76-10.09-21.89-23.24-28.84-37a161.46 161.46 0 01-14.91-44.54c-.38-2.11-.72-4.23-1-6.35q-.75-5.44-1.12-10.94a156.59 156.59 0 016.88-57.85c6.6-20.92 17.6-41 22.44-62.08q.3-1.34.57-2.67a92.43 92.43 0 001.47-9.69c2.47-25.9-7-51.15-14.43-76.48-.26-.88-.52-1.77-.77-2.66q-1.2-4.22-2.3-8.43c-6.88-26.78-8.79-55.45-2.66-82.18.19-.89.42-1.78.64-2.66a120.32 120.32 0 0122.62-46.33c11.48-14.4 26.55-26.39 42.65-36.92q11.77-7.7 24.34-14.39 9-4.8 18.44-9.09c50.45-23 108-34.23 164.91-31.75 3 .13 6 .29 9 .51s6.28.48 9.42.77C463.33 47.72 499 56.31 534.42 65.7c11.87 3.15 23.72 6.38 35.56 9.55 5.27 1.4 10.53 2.8 15.8 4.16 25.81 6.67 52 12.71 78.52 17.22q9.21 1.59 18.44 2.9a528.2 528.2 0 0064.49 5.47q12.59.25 25.19-.22 6.36-.23 12.73-.69C829 101 871.38 90.66 913.83 81q9.21-2.1 18.45-4.14c8.08-1.78 16.16-3.5 24.28-5.09 50.53-9.93 95.57-4.22 142.55 16.27 10.68 4.65 21.35 10.27 27.89 19s8.18 19.45 9.4 29.8c1.73 14.74 2.86 29.67 3.29 44.68 0 .88 0 1.77.06 2.66.68 30.32-1.58 60.93-7.75 90.54z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M796.82 363.55h-3.3v2.67h3.74zm-37.43 0a.17.17 0 000 .07c-.09.73-.19 1.46-.29 2.2v.4h28.6v-.16l2-2.51zm-76.65 0v-86.17h32.9c-.35-.23-.71-.47-1.08-.69l-.48-.31-.62-.38c-.36-.21-.72-.42-1.1-.62s-.61-.34-.93-.51l-.22-.12H682.74V270l-.77.3-.81.38h-.06l-.17.09-.51.27-.51.27c-.5.27-1 .57-1.5.88l-.48.32-1 .64c-1.29.86-2.56 1.76-3.87 2.6-.33.21-.66.42-1 .61-.71.42-1.44.82-2.19 1.18-.32.16-.63.3-1 .43l-.54.21-.5.17a23.42 23.42 0 01-3.6.94v84.24H614.9c0 .1.07.18.1.28.27.8.54 1.59.8 2.39h48.5v92.36h.75l.87.05 1.57.09 2.51.3 1.15.11 1.25.13h.19l2.21.27.47.06 1.07.15 1.53.22 3.67-.16.5.09c.2 0 .41.06.62.1v-93.75H759v-.4c.1-.74.2-1.47.29-2.2a.17.17 0 010-.07zm114.08 0h-3.3v2.67h3.74zm-39.49 0c-.12.89-.23 1.78-.35 2.67h31.89l2.17-2.67zm-74.59 0v-86.17h32.9c-.35-.23-.71-.47-1.08-.69l-.48-.31-.62-.38c-.36-.21-.72-.42-1.1-.62s-.61-.34-.93-.51l-.22-.12h-28.47V270l-.77.3-.81.38h-.06l-.17.09-.51.27-.51.27c-.5.27-1 .57-1.5.88l-.48.32-1 .64c-1.29.86-2.56 1.76-3.87 2.6-.33.21-.66.42-1 .61-.71.42-1.44.82-2.19 1.18-.32.16-.63.3-1 .43l-.54.21-.5.17a23.42 23.42 0 01-3.6.94v84.24H614.9c0 .1.07.18.1.28.27.79.55 1.59.81 2.39h48.49v92.35h.75l.87.05 1.57.09 2.51.31 1.15.11 1.25.13h.19l2.21.27.47.06 1.07.15 1.53.22 3.67-.16.5.09c.2 0 .41.06.62.1v-93.75H757c.12-.89.23-1.78.35-2.67zm249.54-179.44h207.47c0-.89 0-1.78-.06-2.66H932.28V76.83q-9.24 2-18.45 4.14v100.48H688.19l-.57-.51.86-.76 83.93-75.42q-12.6.48-25.19.22l-64.49 57.94V99.53q-9.24-1.31-18.44-2.9V160L570 75.25c-11.84-3.17-23.69-6.4-35.56-9.55l128.23 115.24-.57.51H426.7V44.25q-4.71-.44-9.42-.77c-3-.22-6-.38-9-.51v138.48H243.34V74.72Q234 79 224.9 83.81v97.64h-89.61c-.22.88-.45 1.77-.64 2.66h90.25v90.61h-85.29c.25.89.51 1.78.77 2.66h84.52v86.17h-71.56q-.27 1.33-.57 2.67h72.13v240.93c6 .93 12.21 1.58 18.44 2V366.22h164.91v221.53c6.19-1.65 12.33-3.36 18.45-5.17V366.22h237.6v193.55a157 157 0 0018.28-5.16l.16-.06V366.22h231.09V457q9.2-1.35 18.45-2.59v-88.19h164.32c.54-.89 1.07-1.78 1.6-2.67H932.28v-86.17h199.14c.21-.88.39-1.77.58-2.66H932.28zm-688.94 0h164.91v90.61H243.34zm0 179.44v-86.17h164.91v86.17zM426.7 184.11h237.6v90.61H426.7zm0 179.44v-86.17h237.6v86.17zm487.13 0H682.74v-86.17h231.09zm0-88.83H682.74v-88.18l3.24-2.43h227.85zm-154.44 88.83a.17.17 0 000 .07c-.09.73-.19 1.46-.29 2.2v.4h28.6v-.16l2-2.51zm37.43 0h-3.3v2.67h3.74zm-114.08 0v-86.17h32.9c-.35-.23-.71-.47-1.08-.69l-.48-.31-.62-.38c-.36-.21-.72-.42-1.1-.62s-.61-.34-.93-.51l-.22-.12H682.74V270l-.77.3-.81.38h-.06l-.17.09-.51.27-.51.27c-.5.27-1 .57-1.5.88l-.48.32-1 .64c-1.29.86-2.56 1.76-3.87 2.6-.33.21-.66.42-1 .61-.71.42-1.44.82-2.19 1.18-.32.16-.63.3-1 .43l-.54.21-.5.17a23.42 23.42 0 01-3.6.94v84.24H614.9c0 .1.07.18.1.28.27.8.54 1.59.8 2.39h48.5v92.36h.75l.87.05 1.57.09 2.51.3 1.15.11 1.25.13h.19l2.21.27.47.06 1.07.15 1.53.22 3.67-.16.5.09c.2 0 .41.06.62.1v-93.75H759v-.4c.1-.74.2-1.47.29-2.2a.17.17 0 010-.07z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M322.63 121.73h1.43a2.9 2.9 0 01-1.75-2.33c0-1.84 2.75-3.34 6.11-3.34h42.76c3.36 0 6.1 1.5 6.1 3.34 0 1.83-2.74 3.34-6.1 3.34h-1.43a2.87 2.87 0 011.75 2.32c0 1.57-2 2.89-4.67 3.24h12.31c3.35 0 6.1 1.5 6.1 3.34s-2.75 3.34-6.1 3.34h-42.77c-3.35 0-6.1-1.51-6.1-3.34 0-1.57 2-2.88 4.67-3.24h-12.31c-3.36 0-6.1-1.5-6.1-3.34s2.74-3.33 6.1-3.33zM786.07 153.5h1.43a2.9 2.9 0 01-1.74-2.33c0-1.84 2.74-3.34 6.1-3.34h42.76c3.36 0 6.11 1.5 6.11 3.34 0 1.83-2.75 3.33-6.11 3.33h-1.42a2.9 2.9 0 011.74 2.33c0 1.57-2 2.89-4.67 3.24h12.31c3.36 0 6.1 1.5 6.1 3.34s-2.74 3.34-6.1 3.34h-42.76c-3.36 0-6.11-1.51-6.11-3.34 0-1.57 2-2.89 4.67-3.24h-12.31c-3.35 0-6.1-1.5-6.1-3.34s2.75-3.33 6.1-3.33zM257 289.46h1.42a2.89 2.89 0 01-1.74-2.33c0-1.83 2.75-3.34 6.1-3.34h42.77c3.35 0 6.1 1.51 6.1 3.34 0 1.84-2.75 3.34-6.1 3.34h-1.43a2.86 2.86 0 011.74 2.32c0 1.57-2 2.89-4.67 3.24h12.31c3.36 0 6.11 1.51 6.11 3.34s-2.75 3.34-6.11 3.34h-42.72c-3.36 0-6.1-1.5-6.1-3.34 0-1.56 2-2.88 4.67-3.24H257c-3.36 0-6.11-1.5-6.11-3.34s2.79-3.33 6.11-3.33z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <ellipse
        cx="852.65"
        cy="602.96"
        fill="#536dfe"
        opacity="0.1"
        rx="64.96"
        ry="213.77"
        transform="rotate(-78.45 803.784 618.237)"
      ></ellipse>
      <path
        fill="#3a3768"
        d="M828.56 420.59s11.37-55.81 54.78-50.64c0 0 30 2.06 36.17 21.7v43.41z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#d48a9b"
        d="M1012.18 405.56L625.61 373.51 576 383.85 579.1 453.1 582.48 453.51 586.33 557.5 965.66 625.71 1005.98 591.6 1005.98 478.87 1011.14 475.84 1012.18 405.56z"
      ></path>
      <path
        d="M1012.7 405.56L1011.66 475.84 969.8 495.48 969.28 422.09 1012.7 405.56z"
        opacity="0.05"
      ></path>
      <path
        d="M1005.98 478.94L1006.49 589.54 966.18 623.65 968.77 495.48 1005.98 478.94z"
        opacity="0.05"
      ></path>
      <path
        d="M583 457.65L969.08 504.76 969.28 495.82 582.71 454.13 583 457.65z"
        opacity="0.05"
      ></path>
      <path
        d="M1005.98 483L1005.98 478.94 967.73 495.82 967.73 504.78 1005.98 483z"
        opacity="0.05"
      ></path>
      <path
        fill="#efc6cd"
        d="M575.48 383.85L625.09 373.51 1011.66 405.56 968.25 422.09 575.48 383.85z"
      ></path>
      <path
        d="M970.48 407.55L989.45 408.79 958.01 418.2 942 417.05 970.48 407.55z"
        opacity="0.1"
      ></path>
      <path
        fill="#fff"
        d="M970.48 406.72L989.45 407.96 958.01 417.38 942 416.22 970.48 406.72z"
      ></path>
      <path
        fill="#d3dae1"
        d="M1022.32 444.56c.75-.32 1.54.29 2.34.44.46.09.93 0 1.39.09.93.12 1.85.74 2.74.43M1021.34 445.13c.74-.32 1.54.28 2.34.44.46.08.93 0 1.39.08.93.13 1.85.75 2.74.44M1019.08 446.27c.75-.32 1.55.28 2.35.43.45.09.93 0 1.38.09.94.13 1.86.75 2.74.43"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M888.48 398.21L907.45 399.46 876.01 408.87 860 407.71 888.48 398.21z"
        opacity="0.1"
      ></path>
      <path
        fill="#fff"
        d="M888.48 397.39L907.45 398.63 876.01 408.04 860 406.89 888.48 397.39z"
      ></path>
      <path
        fill="#d3dae1"
        d="M940.32 435.23c.75-.32 1.54.28 2.34.44.46.08.93 0 1.39.08.93.13 1.85.75 2.74.44M939.34 435.8c.74-.32 1.54.28 2.34.43.46.09.93 0 1.39.09.93.13 1.85.75 2.74.43M937.08 436.93c.75-.32 1.55.29 2.35.44.45.09.93 0 1.38.09.94.12 1.86.75 2.74.43"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M927.81 402.88L946.79 404.12 915.35 413.54 899.33 412.38 927.81 402.88z"
        opacity="0.1"
      ></path>
      <path
        fill="#fff"
        d="M927.81 402.06L946.79 403.3 915.35 412.71 899.33 411.55 927.81 402.06z"
      ></path>
      <path
        fill="#d3dae1"
        d="M979.65 439.9c.75-.32 1.55.28 2.35.43.45.09.92 0 1.38.09.93.12 1.86.75 2.74.43M978.67 440.46c.75-.32 1.55.29 2.35.44.45.09.92 0 1.38.09.93.12 1.86.75 2.74.43M976.42 441.6c.74-.32 1.54.28 2.34.44.46.08.93 0 1.39.08.93.13 1.85.75 2.74.44"
        transform="translate(-54.11 -35.71)"
      ></path>
      <ellipse
        cx="498.32"
        cy="749.7"
        fill="#536dfe"
        opacity="0.1"
        rx="202.48"
        ry="41.68"
      ></ellipse>
      <path
        fill="url(#c6e87aad-8151-4bb2-867f-5915ddeef7a8)"
        d="M774.16 444.09C772 425.11 763.45 407 763.45 407l.65-6.4s.14-3.2-.07-8a36.4 36.4 0 011.17-8.88c1.75-5.55-2.19-12.37-2.63-13s.22-12.8-3.72-18.77-30.18-17.07-30.18-17.07-1.41-2.95-3.4-6.4l.18-.35a37.6 37.6 0 00-6-8.09c-1.61-1.72-3.16-2.7-4.41-2.22a36 36 0 01-1.16-5.07c.26.07.53.14.79.19a8.16 8.16 0 003.3.08c2.44-.55 4.06-2.74 5.42-4.8 6.78-10.3 12.62-21.6 13.81-33.79a21.48 21.48 0 00-.35-7.46 25.17 25.17 0 00-2.34-5.45 43.8 43.8 0 00-6.6-9.73c-4.67-4.92-11.11-7.93-17.73-9.71a61.38 61.38 0 00-22.9-1.71c-2 .23-4 .56-6 .69a62.32 62.32 0 01-7.61-.13l-13.09-.76-.06-.2-2.18-.13c-.86 1.71 0 3.74 1.07 5.34s2.3 3.27 2.21 5.16-1.46 3.41-2.53 5-1.88 3.67-.81 5.23a3 3 0 00.53.58c1.13 1.17 3.1 1.3 4.81 1.28h.3a32.57 32.57 0 00-6.63 19.72 33.16 33.16 0 0018.09 29.38c.19.65.38 1.32.56 2a61.26 61.26 0 012.1 21.62l-.23.5-.14-.53s-15.42 10.46-20 13.23-9.18 12.16-9.4 14.72-7.44 41.17-7.44 41.17a94.59 94.59 0 00-3.62 11.92l-9.21 8.09s-19 1.71-24.5.43l.16 1.06a83.09 83.09 0 00-14.76-2 15.65 15.65 0 00-8 1.07l-.19.09-.15.07a31.7 31.7 0 00-8.4 2.36c-.32.13-.61.26-.89.39l.06-1.31-20.56-1.06-10.5-2.13s-3.72-3-5.91-2.56-6.78-2.56-6.78-2.56a18.33 18.33 0 00-3.38-2.1c-.35-2.42-.57-3.89-.57-3.89s-8.17-32.42-14.29-51.48c-4.1-12.73-10-19-13.48-21.73-1.55-2.7-2.57-4.44-2.57-4.44-.67-2.34-4.35-7.61-5.29-7.74-.15-.24-.26-.36-.32-.36a1.17 1.17 0 00-.59.09c-1.72-8.56-2.72-19.29-.09-28.64a31.61 31.61 0 0011.54-24.36v-.42-.43a31.47 31.47 0 00-7.43-20.3l-.34-.38a2.65 2.65 0 00.26-.21 5.36 5.36 0 001.89-5.16c-.45-1.92-1.95-3.43-2.72-5.25a34 34 0 01-1.11-4.28 13.2 13.2 0 00-3.15-5.49l.15.4c-3.92-4.41-10.66-6.6-16.73-5.62-4.51.72-8.71 2.82-13.24 3.47-3.25.46-6.56.16-9.83.49a25.51 25.51 0 00-8.72 2.52 5 5 0 00-1.85 1.36 7.32 7.32 0 00-.92 2.57c-1.11 4.05-4.63 6.94-7.18 10.32a24.15 24.15 0 00-4.84 13.34 10.44 10.44 0 00.35 3.65c.22.71.56 1.38.72 2.1.5 2.2-.65 4.39-1.21 6.57a12.79 12.79 0 00.71 8.34c3.95 8.84 16.92 11.79 19.62 21.07a25.81 25.81 0 006.49 2c.18.92.34 1.85.47 2.79a.75.75 0 00-.17.1c-3.5 3.41-4.37 10-4.37 10l-.42.34c-1.43 1.18-6.32 5.14-10.74 8.19-5.25 3.63-14 15.79-20.12 19.42s-11.16 26-9.84 34.13 6.78 30.93 4.59 39.25 3.28 46.29 3.28 46.29a55.91 55.91 0 0110.72 3.18l-.11 1.66-.33 5s-9.91 35.84-6.12 63.43-1.75 30.43-1.75 30.43 1.16 12.23-1.75 16.5-3.5 13.65-3.5 13.65-.29 21.05.29 27 .87 16.79-1.17 19.35-5.83 19.33-5.54 24.45-7.29 16.79-3.21 31.86-12 15.36-12 15.36 2.05 23 6.42 29.58l.64.94c-.11.38-.22.78-.34 1.21-1.65 6-3.91 15.47-2.34 17.76 2.33 3.42 3.5 2.84 3.5 2.84l.87 15.36s17.5 14.79 30.92 14.23 10.79-14.23 10.79-14.23l-11.43-29.64-.39-1 12.7-24s3.5-10.52 4.37-14.22 5.62-16.81 5.62-16.81 12-28.44 12.25-31.86 1.17-21.89 3.5-25.6 8.75-25 8.75-25l.16.14a8.43 8.43 0 012.18 8.39c-1.47 5.4-.59 16.49-.59 16.49s-.58 9.39-1.75 14.23-1.45 44.37.59 53.75c1.63 7.51 1.58 21.57 1.5 26.89-1.37 5.65-2.57 12.67-.34 13.5 3.8 1.43 23.05 1.14 23.05 1.14s8.16-2.85 19.25 7.11 45.2-2.84 45.2-2.84 10.5-2.85-10.21-11.09c-14.45-5.75-23.78-9.58-29.88-13.68.14-.27.29-.54.42-.83 0 0-8.46-8-1.46-22.18s6.71-26.17 6.71-26.17l1.17-47.79-3.5-63.44-2.71-66.58.48-.16c.46 12.24 2.85 41.38 15.36 35.73 15.75-7.11 2.33-25.6 2.33-25.6l-7.07-13.78 2.11-.72-7.91-25.56a57.65 57.65 0 01-.3-15.07 59.71 59.71 0 00-.18-8.8c10.36-1.81 20.28-3.73 22.06-3.29 2.1.51 13.85.61 18.47.63-1.51 1.18-2.72 2.35-2.72 2.35l18.81 12.66s6.38-3.49 7.71-7.19a8.3 8.3 0 003.52-1.88c.2 4.37 1.36 9.1 5.4 9.21a7 7 0 002.94-.58l30.76-6.09-2.64 16.49 1.84 3.27c-.93 13.91-2 28.68-2.94 41.67l-.43 2.84.22.05c-1.46 20-2.63 35.15-2.63 35.15a18.43 18.43 0 017.67-7.71l.2 29.68s1.54 46.93 1.54 53.33.21 20.69.21 20.69 3.29 17.49 5.25 23.25 3.5 32 3.5 32 4.6 7.25 2.63 10 7.66 8.74 7.66 8.74-6.13 8.32-6.57 13.87c-.05.64.58 1.32 1.72 2-.36.29-.73.58-1.14.86-2.84 1.9-7 3.22-13.26 2.68-17.07-1.5-29.1 14.29-18.6 17.49s42 3.84 42 3.84 9.54-5.95 17-3.27c-.11 6.26.2 12 .25 12.76l-.09.07c-4.46 4-13 10.88-21.34 13.69-12 4.05-14.66 20.48.87 22.61s38.28-2.56 38.28-2.56 11.81-8.74 20.78-10.66 16.63-6.19 15.1-11.31c-1-3.27-3.57-11.84-5.31-17.6q-.15-.52-.3-1c.27-.6.54-1.22.79-1.86 0 0-4.59-23.89-.87-29.86s1.75-65.71 1.75-65.71-6.35-15.14-3.06-24.31-5.25-22.19-5.25-22.19.93-26.09 3.43-40.63l.33-1.8a81.92 81.92 0 0012.2-4.71s2.19-32.86 3.5-40.32c.13-.7.31-1.83.53-3.3l1-5.27 1.18-6 4-20.45 7.22-9.34 18.6-19s4.47-10.04 2.28-29.03zM487.32 326.76l-.14.1a1.74 1.74 0 01-.05-.22.9.9 0 00.19.12zm183.77 23.29l-.72 1.57L673 349l-3.57 4 1.2-2.52zm-17.76 36.7c-.69 1.83-1.43 3.81-2.2 5.87l1.41-4.21z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#585b8a"
        d="M595.94 446.58s-2.45 16.31 4.9 16.52 12.26-12.58 12.26-12.58l-3-10.23z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M595.94 446.58s-2.45 16.31 4.9 16.52 12.26-12.58 12.26-12.58l-3-10.23z"
        opacity="0.2"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#636992"
        d="M431.31 799.62c-13.08.57-30.14-14.21-30.14-14.21l-.85-15.35s-1.13.57-3.41-2.84c-1.53-2.29.67-11.78 2.28-17.75.78-2.92 1.42-5 1.42-5l28.7 7.68 1.37 3.63 11.14 29.62s2.56 13.65-10.51 14.22zM563.18 756.14s-33.25 12.79-44 2.84-18.76-7.11-18.76-7.11-18.76.29-22.46-1.14c-2.18-.83-1-7.94.36-13.6.92-3.91 1.92-7.14 1.92-7.14s32.68-11.09 37.8-4.27a24.51 24.51 0 005.45 5.2c5.92 4.28 15.17 8.16 29.8 14.13 20.12 8.24 9.89 11.09 9.89 11.09z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#ffd6d6"
        d="M533.34 496.35l9.09 18.19s13.08 18.48-2.27 25.58-15.06-40.92-15.06-40.92z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#dce6f2"
        d="M495.25 338.61s9.95 4.55 15.92 23.59 13.93 51.45 13.93 51.45 5.4 36.66 4.54 45.76a59 59 0 00.29 15.06l7.67 25.58-15.35 5.4-23.59-90.38z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M495.25 338.61s9.95 4.55 15.92 23.59 13.93 51.45 13.93 51.45 5.4 36.66 4.54 45.76a59 59 0 00.29 15.06l7.67 25.58-15.35 5.4-23.59-90.38z"
        opacity="0.05"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M429.31 752.16l1.37 3.63L429 759c-6.54 2.84-22.74.57-22.74.57s-3-3.81-7.1-10.08c.78-2.92 1.42-5 1.42-5zM524.53 732.26c-8.29 18.78-36.47 11.81-44.3 9.46-1.29-.39-2-.65-2-.65s.05-1.53.07-3.94c.92-3.91 1.92-7.14 1.92-7.14s32.68-11.09 37.8-4.27a24.51 24.51 0 005.45 5.2 9.64 9.64 0 001.06 1.34z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#565988"
        d="M523.1 708.39c-6.82 14.2 1.43 22.17 1.43 22.17-8.29 18.77-36.47 11.81-44.3 9.45-1.29-.38-2-.64-2-.64s.57-19.62-1.42-29-1.71-48.88-.57-53.71 1.7-14.22 1.7-14.22-.85-11.08.57-16.48a8.51 8.51 0 00-2.12-8.38l-.15-.15s-6.25 21.32-8.53 25-3.12 22.17-3.41 25.58-11.94 31.84-11.94 31.84-4.54 13.07-5.39 16.76-4.27 14.22-4.27 14.22L429 757.27c-6.54 2.84-22.74.57-22.74.57s-3.12-4-7.39-10.52-6.25-29.55-6.25-29.55 15.63-.29 11.65-15.35 3.41-26.72 3.13-31.84 3.41-21.88 5.4-24.44 1.7-13.36 1.13-19.33-.28-27-.28-27 .57-9.38 3.41-13.64 1.71-16.49 1.71-16.49 5.39-2.84 1.7-30.41 6-63.38 6-63.38l.33-5 .52-8.1s81.29-5.12 87.83 1.13a21.56 21.56 0 014.15 5.95A59.2 59.2 0 01524 485l3.41 86.12 3.41 63.38-1.14 47.75s.25 11.92-6.58 26.14z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M499 538.42l-8.53 184.74L480.23 740c-1.29-.38-2-.64-2-.64s.57-19.62-1.42-29-1.71-48.88-.57-53.71 1.7-14.22 1.7-14.22-.85-11.08.57-16.48a8.51 8.51 0 00-2.12-8.38l.14-1zM407.14 736.81s22.17-8.81 25.58-6-26.14 7.1-26.14 7.1zM516.57 713.5c-.85.29-22.45 8-20.46 16.2s20.46-16.2 20.46-16.2z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#ffd6d6"
        d="M449.07 293s7.24 17.48 3.41 26.44 41.35 24.3 41.35 24.3-13.21-34.11-.42-53.3-44.34 2.56-44.34 2.56z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#505484"
        d="M713.61 799.05c-8.74 1.92-20.25 10.66-20.25 10.66s-22.17 4.69-37.31 2.56-12.57-18.55-.85-22.6c8.13-2.8 16.46-9.71 20.81-13.67 1.92-1.77 3.06-3 3.06-3l42.43-8.53s.69 2.37 1.65 5.64c1.7 5.77 4.21 14.33 5.17 17.59 1.49 5.17-5.97 9.43-14.71 11.35zM702.74 766.22s-17.91 1.92-25.37-2.34-18.12 2.56-18.12 2.56-30.7-.64-40.93-3.84 1.49-19 18.12-17.48c6.06.55 10.16-.78 12.93-2.68A13.62 13.62 0 00655 734l36 2.13 5 12.76z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M696.55 754.71s-41.84-6.84-47.18-12.27A13.62 13.62 0 00655 734l36 2.13 5 12.76z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#575988"
        d="M634.52 515.33l.43 62.45s1.49 46.9 1.49 53.3.21 20.67.21 20.67 3.2 17.48 5.12 23.24 3.41 32 3.41 32 4.48 7.25 2.56 10 7.46 8.74 7.46 8.74-6 8.32-6.39 13.86S696.55 753 696.55 753L677.8 560.73l-14.93-48.17z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M634.52 515.33l.43 62.45s1.49 46.9 1.49 53.3.21 20.67.21 20.67 3.2 17.48 5.12 23.24 3.41 32 3.41 32 4.48 7.25 2.56 10 7.46 8.74 7.46 8.74-6 8.32-6.39 13.86S696.55 753 696.55 753L677.8 560.73l-14.93-48.17zM723.15 770.16c-13.93 33.21-47.06 7.58-47.06 7.58s0-.64-.08-1.74c1.92-1.77 3.06-3 3.06-3l42.43-8.53s.69 2.42 1.65 5.69z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#575988"
        d="M723.63 767.29c-13.65 35-47.54 8.74-47.54 8.74s-1.07-18.12 1.07-26.43-2.35-33.26-2.35-33.26-2.56-22.17-4.9-27.28-2.13-15.35-2.13-16.2.85-7.68-1.07-12.37-3-16.2-3-16.2 0-16.2-1.92-25.79l-6.61-33-11.94-67.58 3.73-.64 66.83-11.72s12.58 64 8.31 70.56c-.92 1.44-1.73 4.59-2.4 8.65-2.44 14.52-3.35 40.59-3.35 40.59s8.31 13 5.12 22.17 3 24.3 3 24.3 1.92 59.69-1.71 65.66.86 29.8.86 29.8z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#d28690"
        d="M717.23 330.94s-60.54 42.63-46.9 21.31c7.35-11.48 6-26.1 3.12-37.14a87.64 87.64 0 00-6-16.29s51.44-21.88 44.62-2.27a36.74 36.74 0 00-2 14.24 38 38 0 007.16 20.15zM608.23 428.57s-25.58-7.39-29.84-.14 1.28 23.16 9 25.72 25.44-8.67 25.44-8.67z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#585b8a"
        d="M637.51 416l-10.66 9.81s-18.55 1.7-23.88.42c0 0 4.91 32.83-2.13 36.88l43.06-8.74z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M637.51 416l-10.66 9.81s-18.55 1.7-23.88.42c0 0 4.91 32.83-2.13 36.88l43.06-8.74zM500.65 275.09a32 32 0 01-32 32c-16.42-7.89-32-14.31-32-32a32 32 0 1163.95 0z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#ffd6d6"
        d="M500.65 274.23a31.94 31.94 0 11-7.24-20.23 32 32 0 017.24 20.23z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M519.3 469.9a72.32 72.32 0 01-9.91 5.14s-16.2-2.35-18.54.42-23 3.84-23 3.84-31.55-1.49-36.24-5.54a19.2 19.2 0 00-4.79-2.84l.52-8.1s81.29-5.12 87.83 1.13a21.56 21.56 0 014.13 5.95z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#dce6f2"
        d="M523.25 464.17c-.64 3.62-13.86 9.16-13.86 9.16s-16.2-2.34-18.54.43-23 3.84-23 3.84-31.55-1.5-36.24-5.55-15.14-6-15.14-6-5.33-37.94-3.19-46.25-3.2-31.13-4.48-39.23 3.62-30.48 9.59-34.1 14.5-15.78 19.61-19.4c4.31-3.05 9.07-7 10.46-8.19l.41-.34s.86-6.61 4.27-10 34.74 21.53 34.74 21.53.22 1.92 2.35-1.7c.48-.81 4.61 5.15 5.33 7.67 0 0 17.05 29.85 18.12 36s5.54 26.22 6.39 31.12c.22 1.26.58 5.68 1 11.6.08 1.16.15 2.39.24 3.67.63 9.82 1.31 22.36 1.72 31.84 0 1.08.09 2.12.12 3.12a106.15 106.15 0 01.1 10.78z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M415 387.21s11.72 14.28 15.56 14.28S415 387.21 415 387.21zM439.69 417.91s-19.19 20.89-16.63 24.73 16.63-24.73 16.63-24.73zM425.62 459.48s22-24.09 23-32.4zM453.33 461.18s25.37-13.43 27.5-24.09-27.5 24.09-27.5 24.09zM485.52 331.58L482 340.1l5.86 2.77 5.76 16.1s15.88 31.76 15.24 48.28 2.88 41.35 2.88 41.35l9.16-1.7-4.32-48.59A70.09 70.09 0 00511 376.5c-7.32-16.76-20.94-47.7-21.8-47.7-1.17 0-.35.43-.35.43z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#575989"
        d="M486.37 330.72l-3.52 8.53 5.87 2.77 5.75 16.1s15.88 31.76 15.24 48.28 2.88 41.35 2.88 41.35l9.17-1.7-4.33-48.59a69.82 69.82 0 00-5.57-21.81c-7.32-16.77-20.94-47.7-21.79-47.7-1.18 0-.36.43-.36.43z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#ffd6d6"
        d="M590.18 456c-4.46-.34-15.16-5.75-19.41-8l-1.8-1 .22-16.51a29 29 0 013.26-1.65c5.68-2.48 17.33-5.85 23.17 5 7.88 14.55.21 22.54-5.44 22.16z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M493.41 254a4.73 4.73 0 01-1.49.61c-3.71.81-7.93-2.38-11.11-.33-1.94 1.26-2.39 3.87-2.65 6.17q-.68 6-1.36 11.92a14.71 14.71 0 01-.88 4.11c-1.57 3.59-5.88 5.28-9.81 5.22a5.85 5.85 0 01-4.23-1.4c-.69-.7-1.06-1.68-1.82-2.32-5-4.19-6.52 6.08-5.2 9 2.12 4.77 9.65 9.37 6.49 15.43a5.78 5.78 0 01-2.32 2.33A32 32 0 11493.41 254z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#353045"
        d="M459.21 277.94c.75.63 1.13 1.61 1.82 2.31a5.86 5.86 0 004.23 1.4c3.93.06 8.24-1.62 9.8-5.23a14.24 14.24 0 00.89-4.1l1.36-11.92c.26-2.3.7-4.91 2.65-6.17 3.18-2 7.4 1.14 11.11.33a5.43 5.43 0 004-6.26c-.43-1.91-1.89-3.42-2.64-5.24a34.24 34.24 0 01-1.09-4.27c-2.07-7.76-11.18-12.12-19.1-10.82-4.4.73-8.49 2.83-12.9 3.47-3.16.46-6.39.16-9.58.5a24.18 24.18 0 00-8.5 2.51 4.94 4.94 0 00-1.8 1.36 7.51 7.51 0 00-.9 2.56c-1.07 4-4.51 6.95-7 10.32a24.59 24.59 0 00-4.74 13.31 10.67 10.67 0 00.34 3.65c.21.7.54 1.38.7 2.1.49 2.19-.63 4.38-1.18 6.56a13.12 13.12 0 00.7 8.34c3.84 8.83 16.49 11.78 19.12 21.05a21 21 0 007.44 2c2.58.05 5.36-1.06 6.56-3.35 3.15-6-4.37-10.66-6.49-15.42-1.33-2.93.16-13.19 5.2-8.99z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M712.12 296.55a36.74 36.74 0 00-2 14.24c-1.54 1.31-3.22-2.61-5-1.6-4.88 2.82-10.52 9.53-16.56 9.53a33.17 33.17 0 01-15.07-3.61 87.64 87.64 0 00-6-16.29s51.45-21.88 44.63-2.27z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#d28690"
        d="M721.78 283.76a33.26 33.26 0 11-33.26-33.26 33.25 33.25 0 0133.26 33.26z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#f0f3f7"
        d="M720.36 338.33s-6.26 6.82-7.11 7.38-19 77-19.32 77.89-21.61 69.91-21.61 69.91l-34.11 16.77 2.85-84.42 25-69.62s8.25-9.38 10.8-12.79 34.39-23.88 34.39-23.88l5.44 11.21z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M715.85 332.49l-39.22 28.08-.63-15.42c2.56-3.41 34.39-23.87 34.39-23.87z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#f0f3f7"
        d="M716.7 330.78l-39.22 28.08-.61-15.41c2.56-3.42 34.39-23.88 34.39-23.88z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#585b8a"
        d="M675.56 336.59l1.31 6.86-8.77 8.91 7-15.67s-15 10.45-19.5 13.22-9 12.15-9.17 14.71-7.25 41.14-7.25 41.14-5.33 14.28-3.83 18.33-8.1 131.74-8.1 131.74a19 19 0 0112.82-9.83l-3.42-75.46s4.16-50.2 4.37-50.84 9.7-29.74 9.7-29.74z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M677.73 344.3l-.68 14s-9.49 29.95-12.68 34.85-12.9 34.11-12.9 34.11L646 478l-9.38 4.27-4.62-8.51 7.68-49s14.49-41.35 16.63-45.62L667 356.62z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#663d5c"
        d="M676.87 343.45l-.67 14s-9.49 29.95-12.69 34.85-12.89 34.11-12.89 34.11l-5.44 50.73-9.38 4.26-4.69-8.52 7.68-49s14.49-41.36 16.62-45.62l10.77-22.49z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#d28690"
        d="M566.31 450.31L584.64 463s12.93-7.25 5.4-11.94-14.21-5.4-16.63-5.4-7.1 4.65-7.1 4.65zM580 426.85a2.82 2.82 0 00-1.33 2.41c0 3.89.44 14.19 3.7 9.54 4-5.69 3.27-10.8 9.38-7.11a36 36 0 019.8 9l-1.7-12.22s-12.56-6.2-19.85-1.62z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M722.13 576.08c-.92 1.44-1.73 4.59-2.4 8.65-37.38 11.21-64.73-12.49-64.73-12.49a326.27 326.27 0 01-8.1-34.1c-.67-3.94-.52-11.58.1-20.9l66.83-11.72s12.57 63.95 8.3 70.56z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#585b8a"
        d="M760.5 385.29c-1.7 5.55-1.06 16.84-1.06 16.84l-15.35 72.48s-7.46 55.85-8.74 63.31-3.41 40.29-3.41 40.29c-43.49 21.32-77-7.67-77-7.67a326.8 326.8 0 01-8.1-34.11c-2.14-12.66 4.16-63.38 7.14-85.91.89-6.67 1.49-10.87 1.49-10.87l11.19-41.57s13.75-35.07 18.87-45.3 25.68-33.21 25.68-33.21c2.55-1.62 6.63 4.1 9.66 9.31 2.29 3.94 4 7.6 4 7.6s25.58 11.08 29.41 17 3.2 18.12 3.63 18.76 4.3 7.51 2.59 13.05z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M700.18 359.5s1.92 11.3-3 14.71c-4.75 3.3-40.11 72.83-42.31 77.17.89-6.68 1.49-10.88 1.49-10.88l11.19-41.56s13.76-35.07 18.87-45.31 25.69-33.21 25.69-33.21c2.55-1.62 6.62 4.1 9.65 9.31-4.57 9.49-14.1 27.43-21.58 29.77z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#585b8a"
        d="M699.33 358.65s1.91 11.3-3 14.71-40.1 72.82-42.33 77.16c.89-6.67 1.49-10.87 1.49-10.87l11.19-41.57s13.75-35.07 18.87-45.3 25.68-33.21 25.68-33.21c2.55-1.62 6.63 4.1 9.66 9.31-4.55 9.48-14.09 27.43-21.56 29.77z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M695.95 425.05L683.92 487.64 683.92 487.65 682.77 493.64 682.77 493.65 680.18 507.12 669.13 504.78 663.98 503.69 592.71 488.59 587.47 487.48 575.51 484.95 577.85 469.41 578.82 462.95 587.45 405.65 695.95 425.05z"
      ></path>
      <path
        fill="#d28690"
        d="M683.55 511.92s-28.35 10.23-22.17 22.38 45.83-9.38 45.83-9.38z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M703.8 599.1c0 .85 1.07 11.73 5.33 15.56s-5.33-15.56-5.33-15.56zM675.24 637.68s5.11 14.07 25.36 19.83-25.36-19.83-25.36-19.83zM721.78 283.76a33.25 33.25 0 01-16.67 28.83 17.7 17.7 0 01-5-4.17c-1.45-1.76-2.58-4.16-1.71-6.26.7-1.69 2.55-2.76 3-4.51a6.64 6.64 0 00-.16-3.22c-.37-1.65-.72-3.3-1.08-4.94-.31-1.4-.86-3.05-2.25-3.39s-2.55.82-3.64 1.68c-2.67 2.11-7.79 3.54-11 1.81s-2.31-7.52-2.83-10.65a1.86 1.86 0 00-.7-1.41 2.92 2.92 0 00-1.45-.1c-1.73 0-3.12-1.55-3.62-3.21a27.63 27.63 0 01-.58-5.15c-.19-1.73-.82-3.56-2.3-4.45A7.11 7.11 0 00668 264l-6.27.07a33.26 33.26 0 0160 19.72z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#663d5c"
        d="M695.16 287.78c1.09-.86 2.29-2 3.64-1.67s1.93 2 2.24 3.38l1.08 4.93a6.7 6.7 0 01.17 3.23c-.51 1.76-2.35 2.82-3.06 4.51-.87 2.1.27 4.5 1.71 6.25a18 18 0 0010.29 6.15 7.56 7.56 0 003.21.07c2.38-.55 4-2.74 5.28-4.79 6.61-10.3 12.3-21.59 13.46-33.77a21.66 21.66 0 00-.34-7.45 25 25 0 00-2.28-5.45 44 44 0 00-6.43-9.73c-4.55-4.9-10.83-7.91-17.28-9.69a58.52 58.52 0 00-22.31-1.75c-2 .23-3.92.56-5.89.69a59.28 59.28 0 01-7.42-.12l-14.72-.88c-.84 1.71 0 3.74 1 5.34s2.24 3.26 2.16 5.16-1.43 3.4-2.47 5-1.83 3.67-.79 5.23 3.16 1.66 5 1.64l7.42-.08a7.09 7.09 0 013.77.65c1.48.89 2.11 2.73 2.3 4.45a29.43 29.43 0 00.58 5.15c.51 1.66 1.89 3.23 3.62 3.21a2.7 2.7 0 011.45.11 1.84 1.84 0 01.7 1.4c.52 3.13-.44 8.91 2.83 10.65s8.41.29 11.08-1.82z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M737.43 353.47a16.3 16.3 0 00-17.15 10.95c-4 11.39-10.67 31.94-9 40.06 2.35 11.51 5.12 30.7 5.12 30.7s12.15 7 6 14.06-7.89 17.06-7.89 17.06-7.89 3.41-9.59 10.66-13.22 17.26-13.22 17.26l-17.26 17.27s28.56 29 34.32 30.48l17.69-20.68 20.89-27.71 18.12-19s4.26-10 2.13-29-10.45-37.09-10.45-37.09l.64-6.4s1.96-45.85-20.35-48.62z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#585b8a"
        d="M739.13 353.47A16.3 16.3 0 00722 364.42c-4 11.39-10.67 31.94-9 40.06 2.34 11.51 5.11 30.7 5.11 30.7s12.15 7 6 14.06-7.88 17.06-7.88 17.06-7.89 3.41-9.6 10.66-13.21 17.26-13.21 17.26l-17.27 17.27s28.56 29 34.32 30.48l17.69-20.68L749 493.58l18.12-19s4.27-10 2.13-29-10.44-37.09-10.44-37.09l.64-6.4s1.99-45.85-20.32-48.62z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M721.28 418.34s18.12 22.16 25.8 17.26-25.8-17.26-25.8-17.26zM728.1 401.28c1.92.64 17.7 22.6 25.8 20s-25.8-20-25.8-20zM732.58 439s1.07 12.58 14.07 10.87S732.58 439 732.58 439z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M621.02 301.83L613.99 317.5 622.77 308.59 621.02 301.83z"
        opacity="0.1"
      ></path>
      <path
        fill="#f0f3f7"
        d="M621.02 300.98L613.99 316.65 622.77 307.74 621.02 300.98z"
      ></path>
      <path
        d="M592.71 488.59L587.47 487.48 577.85 469.41 578.82 462.95 592.71 488.59z"
        opacity="0.3"
      ></path>
      <path
        d="M683.92 487.65L682.77 493.64 682.77 493.65 669.13 504.78 663.98 503.69 683.92 487.65z"
        opacity="0.3"
      ></path>
      <path
        d="M523.12 453.43c-2.64.44-5.2.84-7.54 1.14-13 1.71-43.92-13.64-43.92-13.64s-37.73-31.55-48.6-61.39 13-34.32 13-34.32c9-5.12 28.57 9.16 31.34 11.51s5.12 8.31 4.9 12.15 6.4 8.74 6.4 8.74 11.3 19.61 14.07 21.74 3.41 4.05 4.26 7.68 8.31 6.61 11.51 6.39 7 1.07 7 2.77c0 1.37 3.13 2.05 5.7 2.27.76 10.93 1.51 25.25 1.88 34.96z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M523 450.31c-2 .32-3.92.61-5.72.85-13 1.71-43.91-13.64-43.91-13.64s-37.73-31.55-48.6-61.39 13-34.32 13-34.32c9-5.12 28.56 9.16 31.33 11.51s5.12 8.31 4.91 12.15 6.39 8.74 6.39 8.74 11.3 19.61 14.07 21.74 3.41 4.05 4.27 7.68 8.31 6.6 11.51 6.39 7 1.07 7 2.77c0 1 1.78 1.67 3.76 2 .08 1.16.15 2.39.24 3.67.66 9.83 1.34 22.37 1.75 31.85zM572.45 428.84l-.81 19.16h-.87l-1.8-1 .22-16.51a29 29 0 013.26-1.65z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#dce6f2"
        d="M436.06 343.51s-23.87 4.48-13 34.32 48.6 61.4 48.6 61.4 30.91 15.34 43.92 13.64 32.82-6.18 35.38-5.54 19.83.64 19.83.64l.85-20-20-1.07-10.23-2.13s-3.63-3-5.76-2.56-6.6-2.56-6.6-2.56-3.42-2.77-6-2.77-7.46-.64-7.46-2.34-3.84-3-7-2.77-10.71-2.77-11.59-6.44-1.49-5.54-4.26-7.67-14.07-21.75-14.07-21.75-6.61-4.9-6.4-8.73-2.13-9.81-4.9-12.16-22.37-16.62-31.31-11.51z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M497.46 412.15s-9.17 9.17-6.83 10.87zM507.26 419.4s-11.94 9.17-8.74 9.81 8.74-9.81 8.74-9.81zM487 433c1.71.86 27.07 16 36.67 15.78zM488.72 331.79s-4.48 14.71-6.19 14.71c-1.34 0-23.84-18.22-33.23-25.88l.41-.34s.85-6.61 4.26-10 34.75 21.51 34.75 21.51z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#dce6f2"
        d="M487.86 330.08s-4.47 14.71-6.18 14.71c-1.35 0-23.85-18.22-33.24-25.88l.41-.34s.86-6.61 4.27-10 34.74 21.51 34.74 21.51z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <g opacity="0.15">
        <path
          d="M427.49 282.54c3 6.85 11.26 10.17 16.05 15.63-2.85-6.71-11.18-10-16.05-15.63zM458.06 298.32c-1.19 2.29-4 3.4-6.56 3.35a19.14 19.14 0 01-6.58-1.68 12.79 12.79 0 011.7 3.62 20.9 20.9 0 007.44 2c2.59.06 5.37-1.05 6.56-3.35 1.91-3.65-.08-6.77-2.41-9.72a6.35 6.35 0 01-.15 5.78zM495.17 248.2c-.43-1.92-1.89-3.43-2.64-5.24a32.72 32.72 0 01-1.09-4.28 13.26 13.26 0 00-3.07-5.49 12.76 12.76 0 01.51 1.51A34.39 34.39 0 00490 239c.75 1.81 2.21 3.32 2.64 5.24a5.43 5.43 0 01-4 6.26c-3.7.81-7.92-2.39-11.1-.33-1.95 1.25-2.4 3.86-2.66 6.16q-.67 6-1.36 11.93a14.3 14.3 0 01-.88 4.1c-1.57 3.6-5.88 5.29-9.81 5.23a5.89 5.89 0 01-4.22-1.4 27.87 27.87 0 00-1.83-2.32c-5-4.2-6.52 6.07-5.2 9a18.12 18.12 0 002.44 3.67c-1.1-3.3.44-12.8 5.32-8.73a25.82 25.82 0 011.82 2.32 5.93 5.93 0 004.23 1.4c3.93.06 8.24-1.63 9.81-5.23a14.3 14.3 0 00.88-4.11q.68-6 1.36-11.92c.26-2.3.71-4.91 2.65-6.16 3.19-2.06 7.41 1.14 11.11.32a5.42 5.42 0 003.97-6.23z"
          transform="translate(-54.11 -35.71)"
        ></path>
      </g>
      <path
        d="M716.57 312.08a7.73 7.73 0 01-3.21-.08 18 18 0 01-10.28-6.14c-1.45-1.76-2.59-4.16-1.71-6.26.7-1.69 2.54-2.75 3-4.51a6.7 6.7 0 00-.17-3.23l-1.08-4.93c-.31-1.4-.85-3.05-2.24-3.38s-2.55.81-3.64 1.67c-2.67 2.11-7.8 3.55-11 1.81s-2.31-7.52-2.83-10.65a1.87 1.87 0 00-.7-1.4 2.85 2.85 0 00-1.46-.11c-1.73 0-3.11-1.55-3.62-3.21a28.39 28.39 0 01-.57-5.15c-.2-1.72-.82-3.56-2.31-4.45a7.19 7.19 0 00-3.77-.65l-7.42.08c-1.83 0-4-.12-5-1.64s-.26-3.68.79-5.23 2.38-3.09 2.47-5-1.15-3.56-2.16-5.16a9.25 9.25 0 01-1.26-2.86l-2.13-.13c-.83 1.7 0 3.73 1 5.34s2.25 3.26 2.16 5.15-1.42 3.41-2.47 5-1.82 3.67-.78 5.23 3.15 1.67 5 1.65l7.42-.09a7.18 7.18 0 013.77.66c1.49.89 2.12 2.73 2.31 4.45a27.63 27.63 0 00.58 5.15c.5 1.65 1.89 3.23 3.62 3.2a2.93 2.93 0 011.45.11 1.88 1.88 0 01.7 1.41c.52 3.12-.44 8.91 2.83 10.65s8.37.3 11-1.81c1.09-.86 2.3-2 3.65-1.68s1.93 2 2.23 3.38l1.09 4.94a6.69 6.69 0 01.16 3.23c-.5 1.75-2.35 2.82-3.05 4.5-.87 2.1.26 4.51 1.71 6.26a18 18 0 0010.35 6.14 7.73 7.73 0 003.21.08 7.54 7.54 0 004.16-3.16 5.56 5.56 0 01-1.8.82z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <ellipse
        cx="203.69"
        cy="714.3"
        fill="#536dfe"
        opacity="0.1"
        rx="24.17"
        ry="3.71"
      ></ellipse>
      <ellipse
        cx="1047.61"
        cy="617.84"
        fill="#536dfe"
        opacity="0.1"
        rx="24.17"
        ry="3.71"
      ></ellipse>
      <ellipse
        cx="801.2"
        cy="767.34"
        fill="#536dfe"
        opacity="0.1"
        rx="70"
        ry="10.74"
      ></ellipse>
      <ellipse
        cx="1000.19"
        cy="721.84"
        fill="#536dfe"
        opacity="0.1"
        rx="54.6"
        ry="8.38"
      ></ellipse>
      <ellipse
        cx="991.2"
        cy="805.34"
        fill="#536dfe"
        opacity="0.1"
        rx="92.59"
        ry="14.21"
      ></ellipse>
      <ellipse
        cx="100.24"
        cy="817.84"
        fill="#536dfe"
        opacity="0.1"
        rx="70"
        ry="10.74"
      ></ellipse>
      <path
        fill="#536dfe"
        d="M258.9 631.85s2.74 3.58-1.26 9-7.3 10-6 13.34c0 0 6-10 11-10.18s1.67-6.12-3.74-12.16z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M258.9 631.85a4 4 0 01.56 1.12c4.8 5.64 7.35 10.89 2.74 11-4.29.12-9.44 7.8-10.67 9.74a3.73 3.73 0 00.14.44s6-10 11-10.18 1.64-6.08-3.77-12.12z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#ffd037"
        d="M264 636.41c0 1.26-.15 2.28-.32 2.28s-.32-1-.32-2.28.18-.66.35-.66.29-.6.29.66z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#ffd037"
        d="M265.74 637.92c-1.1.6-2.07 1-2.15.81s.74-.76 1.85-1.37.67-.16.75 0 .66-.05-.45.56z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M244.44 631.85s-2.74 3.58 1.26 9 7.31 10 6 13.34c0 0-6-10-10.95-10.18s-1.75-6.12 3.69-12.16z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M244.44 631.85a4.41 4.41 0 00-.56 1.12c-4.8 5.64-7.35 10.89-2.74 11 4.29.12 9.44 7.8 10.68 9.74a3.81 3.81 0 01-.15.44s-6-10-10.95-10.18-1.72-6.08 3.72-12.12z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#ffd037"
        d="M239.35 636.41c0 1.26.14 2.28.31 2.28s.32-1 .32-2.28-.18-.66-.35-.66-.28-.6-.28.66z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#ffd037"
        d="M237.6 637.92c1.11.6 2.07 1 2.16.81s-.75-.76-1.86-1.37-.67-.16-.75 0-.66-.05.45.56z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <ellipse
        cx="197.56"
        cy="641.47"
        fill="#536dfe"
        opacity="0.1"
        rx="28.63"
        ry="4.39"
      ></ellipse>
      <path
        fill="#65617d"
        d="M266.41 649.35l-.14 1.12-.19 1.58-.08.66-.19 1.58-.09.66-.19 1.58-2.19 18c-.19 1.6-2.81 2.85-6 2.85H246c-3.16 0-5.78-1.25-6-2.85l-2.19-18-.19-1.58-.08-.66-.2-1.58-.08-.66-.19-1.58-.14-1.12c-.11-.91 1.31-1.67 3.1-1.67h23.29c1.78 0 3.2.76 3.09 1.67z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#9d9cb5"
        d="M212.16 614.76L211.97 616.34 183.15 616.34 182.96 614.76 212.16 614.76z"
      ></path>
      <path
        fill="#9d9cb5"
        d="M211.89 617L211.7 618.58 183.43 618.58 183.23 617 211.89 617z"
      ></path>
      <path
        fill="#9d9cb5"
        d="M211.62 619.24L211.42 620.82 183.7 620.82 183.51 619.24 211.62 619.24z"
      ></path>
      <path
        fill="#536dfe"
        d="M1082.67 618s-3.42 15.92 11.79 17.8l.94-1.77s-11.79-11.09-12.73-16.03z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1100.24 633.9l-3.54.75-.35.08s-9.44-7.66-9.32-24.76a42.22 42.22 0 004.51 7.13c3.74 4.95 7.99 11.55 8.7 16.8z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1101.43 635.54a2.22 2.22 0 01-1.9.25c-9.08-2.12-6-31.71-6-31.71.5.23 1 4 3.14 8.86 3.65 8.53 7.68 20.46 4.76 22.6zM1121.57 618s.59 15.92-14.62 17.8l-.95-1.8s14.63-11.06 15.57-16z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1117.21 610c.12 17.1-12.14 24.76-12.14 24.76l-.36-.08-3.53-.75c.7-5.25 5-11.85 8.69-16.8a38.47 38.47 0 017.34-7.13z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1104.66 634a5.52 5.52 0 01-2 1.55 3.89 3.89 0 01-.75.25c-2.23.52-3-1.09-2.88-3.83.21-4.87 3.27-13.32 6-19.65a24.56 24.56 0 015.7-8.23s-.14 23.03-6.07 29.91z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1102.12 593.7s-10.14 36-1.41 41.38 3.65-38.2 1.41-41.38z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M1082.67 618s-3.42 15.92 11.79 17.8l.94-1.77s-11.79-11.09-12.73-16.03z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M1100.24 633.9l-3.54.75-.35.08s-9.44-7.66-9.32-24.76a42.22 42.22 0 004.51 7.13c3.74 4.95 7.99 11.55 8.7 16.8z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M1101.43 635.54a2.22 2.22 0 01-1.9.25c-9.08-2.12-6-31.71-6-31.71.5.23 1 4 3.14 8.86 3.65 8.53 7.68 20.46 4.76 22.6zM1121.57 618s.59 15.92-14.62 17.8l-.95-1.8s14.63-11.06 15.57-16z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M1117.21 610c.12 17.1-12.14 24.76-12.14 24.76l-.36-.08-3.53-.75c.7-5.25 5-11.85 8.69-16.8a38.47 38.47 0 017.34-7.13z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M1104.66 634a5.52 5.52 0 01-2 1.55 3.89 3.89 0 01-.75.25c-2.23.52-3-1.09-2.88-3.83.21-4.87 3.27-13.32 6-19.65a24.56 24.56 0 015.7-8.23s-.14 23.03-6.07 29.91z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M1102.12 593.7s-10.14 36-1.41 41.38 3.65-38.2 1.41-41.38z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1082.67 618s-2 15.92 13.2 17.8l.94-1.77s-13.2-11.09-14.14-16.03z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1101.65 633.9l-3.54.75-.35.08s-10.85-7.66-10.76-24.73c0 0 2.78 3 5.92 7.13 3.77 4.92 8.02 11.52 8.73 16.77z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M1101.65 633.9l-3.54.75c-3.35-2.94-4.68-10.62-5.16-17.55 3.74 4.95 7.99 11.55 8.7 16.8z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1102.85 635.54a2.24 2.24 0 01-1.91.25c-9.08-2.12-7.42-31.71-7.42-31.71.5.23 2.46 4 4.55 8.86 3.67 8.53 7.69 20.46 4.78 22.6zM1121.57 618s2 15.92-13.2 17.8l-.94-1.77s13.2-11.09 14.14-16.03z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1117.21 610c.12 17.1-10.73 24.76-10.73 24.76l-.35-.08-3.54-.75c.7-5.25 5-11.85 8.7-16.8 3.14-4.13 5.92-7.13 5.92-7.13z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M1111.29 617.1c-.46 6.46-1.64 13.57-4.51 16.89a5.08 5.08 0 01-.65.66l-3.54-.75c.7-5.25 4.96-11.85 8.7-16.8z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1106.07 634a5.41 5.41 0 01-2 1.55 4 4 0 01-.74.25c-2.24.52-3-1.09-2.89-3.83.22-4.87 3.28-13.32 6-19.65 2-4.55 3.81-8 4.29-8.23 0-.01 1.27 23.03-4.66 29.91z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M1102.85 635.54a2.4 2.4 0 01-1.44-.46c-4.27-2.66-4.36-12.64-3.34-22.14 3.67 8.53 7.69 20.46 4.78 22.6z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M1106.07 634c-.49 1.07-1.15 1.63-2 1.55a2.69 2.69 0 01-1.21-.46 6.46 6.46 0 01-2.42-3.12c.22-4.87 3.28-13.32 6-19.65.98 8.77 1.31 18.07-.37 21.68z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M1102.12 593.7s-8.72 36 0 41.38 2.24-38.2 0-41.38z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#4b4770"
        d="M1064.75 597.61L1028.44 597.61 1028.44 603.62 1033.98 603.62 1034.12 604.33 1036.34 616 1057.45 616 1059.67 604.33 1059.8 603.62 1064.75 603.62 1064.75 597.61z"
      ></path>
      <path
        d="M1064.75 597.61L1028.44 597.61 1028.44 603.62 1033.98 603.62 1034.12 604.33 1036.34 616 1057.45 616 1059.67 604.33 1059.8 603.62 1064.75 603.62 1064.75 597.61z"
        opacity="0.1"
      ></path>
      <path
        fill="#4b4770"
        d="M1061.69 601.14L1061.08 604.33 1058.86 616 1037.75 616 1035.53 604.33 1034.92 601.14 1061.69 601.14z"
      ></path>
      <path
        d="M1061.69 601.14L1061.08 604.33 1035.53 604.33 1034.92 601.14 1061.69 601.14z"
        opacity="0.1"
      ></path>
      <path
        fill="#4b4770"
        d="M1029.85 597.61H1066.1599999999999V603.62H1029.85z"
      ></path>
      <path
        fill="#536dfe"
        d="M193.5 736.16a17.44 17.44 0 00-2.28 4.3c-.14.37-.28.8-.42 1.21a4.36 4.36 0 00-.79-.28 11 11 0 00-3.57-.3c0-.47.06-1 .07-1.47.15-5.27-.47-12.61-5.5-9.5-4.82 3-1.38 8 1.73 11.2.27.28.54.54.8.79-2.84 2-3.38 6.73-3.85 11.64s-4.64 10.28-7.41 13.33c-.28.31-.53.59-.78.85a10.15 10.15 0 00-8.05-2.07c-.11-.43-.24-.88-.37-1.35-2.24-8.09-6.89-22.1-12.82-25.17l.78-1c2.52-3.29 5.36-8.19 1.17-9.44s-4.57 4.24-4.34 8.36q.06.78.12 1.47a6.13 6.13 0 00-4.38 2.14l-.65-.77c-3.4-4-9.63-10.37-11.52-5.56-1.76 4.48 3.73 10.3 7.59 13.67l.24.21c-2.59 10.51 8.72 19.08 14.81 22.83l.79.48c-8.4 9.9-13.59 28.46-13.59 28.46l23.52 4.2s15.6-13.46 13.6-26.1h.16c15.59-3.12 19.13-19.74 16.7-29.61l.28-.11a17.65 17.65 0 007.22-5.46c4.36-6.05-4.76-12.89-9.26-6.95z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M193.5 736.16a17.44 17.44 0 00-2.28 4.3c-.14.37-.28.8-.42 1.21a4.36 4.36 0 00-.79-.28 11 11 0 00-3.57-.3c0-.47.06-1 .07-1.47.15-5.27-.47-12.61-5.5-9.5-4.82 3-1.38 8 1.73 11.2.27.28.54.54.8.79-2.84 2-3.38 6.73-3.85 11.64s-4.64 10.28-7.41 13.33c-.28.31-.53.59-.78.85a10.15 10.15 0 00-8.05-2.07c-.11-.43-.24-.88-.37-1.35-2.24-8.09-6.89-22.1-12.82-25.17l.78-1c2.52-3.29 5.36-8.19 1.17-9.44s-4.57 4.24-4.34 8.36q.06.78.12 1.47a6.13 6.13 0 00-4.38 2.14l-.65-.77c-3.4-4-9.63-10.37-11.52-5.56-1.76 4.48 3.73 10.3 7.59 13.67l.24.21c-2.59 10.51 8.72 19.08 14.81 22.83l.79.48c-8.4 9.9-13.59 28.46-13.59 28.46l23.52 4.2s15.6-13.46 13.6-26.1h.16c15.59-3.12 19.13-19.74 16.7-29.61l.28-.11a17.65 17.65 0 007.22-5.46c4.36-6.05-4.76-12.89-9.26-6.95z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M146.68 743l-2.75 8s-1.53-1.08-3.46-2.78c-3.86-3.37-9.35-9.19-7.59-13.67 1.89-4.81 8.12 1.54 11.52 5.56 1.37 1.6 2.28 2.89 2.28 2.89zM152.48 738.35a38.1 38.1 0 01-2.68 3.16 42.2 42.2 0 01-.49-4.24c-.23-4.12.21-9.59 4.34-8.36s1.35 6.15-1.17 9.44zM188 739.62c-.08 2.65-.34 4.77-.34 4.77a34.92 34.92 0 01-3.43-3.07c-3.11-3.23-6.55-8.21-1.73-11.2 4.98-3.12 5.6 4.23 5.5 9.5zM204.2 743.09a17.65 17.65 0 01-7.22 5.46 21.62 21.62 0 01-2.42.88l-3.24-4.55a32.17 32.17 0 011.34-4.42 17.44 17.44 0 012.28-4.3c4.48-5.94 13.62.9 9.26 6.93z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M144.4 740.11c1.37 1.6 2.28 2.84 2.28 2.84l-2.75 8s-1.53-1.08-3.46-2.78a15.7 15.7 0 013.1-7.07c.27-.33.56-.67.83-.99zM152.48 738.35a38.1 38.1 0 01-2.68 3.16 42.2 42.2 0 01-.49-4.24 5.53 5.53 0 013.17 1.08z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M166 770.31l-6.84 3s-1.49-.72-3.64-2.06c-7.19-4.42-21.64-15.55-12-28.67s17.77 10.41 21 21.92c.97 3.5 1.48 5.81 1.48 5.81z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        d="M184.18 741.32a5.62 5.62 0 013.77-1.7c-.08 2.65-.34 4.77-.34 4.77a34.92 34.92 0 01-3.43-3.07zM197 748.55a21.62 21.62 0 01-2.42.88l-3.24-4.55a32.17 32.17 0 011.34-4.42c2.07 1.22 3.61 4.26 4.32 8.09z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M180 778.27c-.37.08-.76.15-1.15.21-22.93 3.48-7.56-8.89-7.56-8.89s1-1 2.43-2.51c2.77-3.05 6.93-8.39 7.41-13.33.72-7.43 1.55-14.4 10.32-12.36 8.61 2.02 10.26 32.53-11.45 36.88z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#d4dfec"
        d="M81.65 799.65H125.46000000000001V811.17H81.65z"
      ></path>
      <path
        fill="#d4dfec"
        d="M74.69 762.21H131.93V802.4100000000001H74.69z"
      ></path>
      <path
        d="M81.65 799.65H125.46000000000001V811.17H81.65z"
        opacity="0.1"
      ></path>
      <path
        d="M74.69 762.21H131.93V802.4100000000001H74.69z"
        opacity="0.1"
      ></path>
      <path fill="#d4dfec" d="M84.53 799.65H128.34V811.17H84.53z"></path>
      <path
        d="M164.52 764.51c1 3.44 1.48 5.8 1.48 5.8l-6.84 3s-1.49-.72-3.64-2.06c2.68-3.39 5.7-5.95 9-6.74zM180 778.27c-.37.08-.76.15-1.15.21-22.93 3.48-7.56-8.89-7.56-8.89s1-1 2.43-2.51c4.28 3.43 6.05 7.29 6.28 11.19z"
        opacity="0.1"
        transform="translate(-54.11 -35.71)"
      ></path>
      <path
        fill="#536dfe"
        d="M142.72 800.2s12.84-46 30.85-31.81-7.33 36-7.33 36z"
        transform="translate(-54.11 -35.71)"
      ></path>
      <circle cx="95.09" cy="714.08" r="1.44" opacity="0.1"></circle>
      <circle cx="94.97" cy="720.8" r="1.44" opacity="0.1"></circle>
      <circle cx="136.74" cy="715.4" r="1.44" opacity="0.1"></circle>
      <circle cx="103.14" cy="749.85" r="1.44" opacity="0.1"></circle>
      <circle cx="133.74" cy="726.56" r="1.44" opacity="0.1"></circle>
      <circle cx="118.86" cy="741.45" r="1.44" opacity="0.1"></circle>
      <circle cx="100.01" cy="716.96" r="1.44" opacity="0.1"></circle>
      <circle cx="132.78" cy="719.72" r="1.44" opacity="0.1"></circle>
      <circle cx="127.86" cy="730.88" r="1.44" opacity="0.1"></circle>
      <circle cx="112.74" cy="748.77" r="1.44" opacity="0.1"></circle>
      <circle cx="109.62" cy="741.69" r="1.44" opacity="0.1"></circle>
      <circle cx="102.17" cy="725.72" r="1.44" opacity="0.1"></circle>
      <path d="M84.53 799.65H128.34V803.86H84.53z" opacity="0.1"></path>
      <path
        fill="#d4dfec"
        d="M77.57 762.21H134.81V802.4100000000001H77.57z"
      ></path>
      <circle cx="114.66" cy="755.25" r="1.44" opacity="0.1"></circle>
      <circle cx="106.02" cy="757.05" r="1.44" opacity="0.1"></circle>
      <circle cx="50" cy="52" r="10.46" fill="#536dfe" opacity="0.1"></circle>
      <circle
        cx="1054.57"
        cy="381.09"
        r="14"
        fill="#536dfe"
        opacity="0.1"
      ></circle>
      <circle
        cx="1081.56"
        cy="351.09"
        r="10.22"
        fill="#536dfe"
        opacity="0.1"
      ></circle>
      <circle cx="68" cy="14" r="14" fill="#536dfe" opacity="0.1"></circle>
      <circle cx="14" cy="78" r="14" fill="#536dfe" opacity="0.1"></circle>
    </svg>
  );
}

export default Icon;
